@if (isTabModalOpen) {
<div class="modal modal-open">
  <div
    class="modal-box p-0 overflow-hidden w-full max-w-lg max-h-[90vh] transition-colors duration-500 shadow-2xl shadow-slate-900/10 rounded-[2rem] flex flex-col"
    [style.background]="currentTheme?.theme_config?.backgroundColor"
  >
    <!-- Live Preview Header -->
    <div
      class="p-8 pb-12 transition-all duration-500 shrink-0"
      [style.background]="headerStyle"
    >
      <!-- Logo & Buttons Row -->
      <div class="flex justify-between items-start mb-6">
        <div class="flex flex-col">
          <div class="flex items-center gap-1">
            <span
              class="text-2xl font-black tracking-tighter"
              [style.color]="currentTheme?.theme_config?.primaryColor"
              >supidoo</span
            >
          </div>
          <span
            class="text-[8px] font-bold opacity-60 -mt-1"
            [style.color]="currentTheme?.theme_config?.headerSubTextColor"
            >Sab kuchh, Supidoo par.</span
          >
        </div>
        <div class="flex gap-2">
          <div
            class="flex flex-col items-center justify-center bg-white w-10 h-10 rounded-full shadow-sm border border-slate-100"
          >
            <i class="fi fi-ss-bell w-4 h-4 text-slate-800"></i>
          </div>
          <div
            class="flex flex-col items-center justify-center bg-white w-10 h-10 rounded-full shadow-sm border border-slate-100"
          >
            <i class="fi fi-sr-user w-4 h-4 text-slate-800"></i>
          </div>
        </div>
      </div>

      <!-- Delivery Info -->
      <div class="flex flex-col mb-6">
        <div class="flex items-center gap-2">
          <div>
            <i
              class="fi fi-sr-bolt w-8 h-8 fill-current"
              [style.color]="currentTheme?.theme_config?.secondaryColor"
            ></i>
          </div>

          <h2
            class="text-3xl font-black tracking-tight"
            [style.color]="currentTheme?.theme_config?.headerTextColor"
          >
            10 mins
          </h2>
        </div>
        <div class="flex items-center gap-1 mt-0.5">
          <span
            class="text-[10px] font-black"
            [style.color]="currentTheme?.theme_config?.primaryColor"
            >HOME</span
          >
          <span
            class="text-[10px] font-bold opacity-80"
            [style.color]="currentTheme?.theme_config?.headerTextColor"
            >- Azad Nagar</span
          >
          <svg
            lucideIcon="chevron-down"
            class="w-3 h-3"
            [style.color]="currentTheme?.theme_config?.headerTextColor"
          ></svg>
        </div>
      </div>

      <!-- Live Header Title with SVG/Image -->
      <div class="flex items-center gap-3 mb-6">
        <div
          class="w-10 h-10 flex items-center justify-center shrink-0"
          [style.color]="currentTheme?.theme_config?.headerTextColor"
        >
          @if (newTabForm.icon_url) {
          <img
            [src]="newTabForm.icon_url"
            class="w-full h-full object-contain"
            alt=""
          />
          } @else {
          <div class="text-[8px] font-black opacity-20">ICON</div>
          }
        </div>
        <h3
          class="font-black text-3xl tracking-tight"
          [style.color]="currentTheme?.theme_config?.headerTextColor"
        >
          {{ newTabForm.name || (isEditingTab ? 'Edit Tab' : 'New Tab') }}
        </h3>
      </div>

      <!-- Search Bar Preview -->
      <div
        class="mt-6 p-4 rounded-[1.25rem] flex items-center gap-3 transition-all duration-500 shadow-sm border border-black/5"
        [style.background]="currentTheme?.theme_config?.searchBarBackground"
      >
        <span
          class="text-sm font-bold transition-colors duration-500 opacity-60 flex-1 truncate"
          [style.color]="currentTheme?.theme_config?.searchPlaceholderColor"
        >
          {{ newTabForm.search_placeholder || 'Search for items...' }}
        </span>
        <div class="w-px h-6 bg-slate-200 mx-1"></div>
        <svg
          lucideIcon="mic"
          class="size-5"
          [style.color]="currentTheme?.theme_config?.primaryColor"
        ></svg>
      </div>
    </div>

    <!-- Form Fields -->
    <div
      class="flex-1 overflow-y-auto p-7 bg-white/85 backdrop-blur-2xl shadow-[0_-24px_48px_rgba(0,0,0,0.07)] border-t border-white/60 -mt-6 relative z-10 space-y-4 rounded-t-[2rem] no-scrollbar"
    >
      <!-- Tab Title -->
      <div class="form-control">
        <label for="tab-title" class="label pb-1"
          ><span
            class="label-text font-bold text-[10px] uppercase tracking-[0.15em] text-slate-500"
            >Tab Title</span
          ></label
        >
        <input
          id="tab-title"
          type="text"
          [(ngModel)]="newTabForm.name"
          class="input input-md bg-white border-slate-200 shadow-sm font-black text-slate-800 w-full rounded-2xl focus:border-primary focus:ring-4 focus:ring-primary/10 transition-all"
          placeholder="e.g. Groceries, Fresh, Beauty"
        />
      </div>

      <!-- Theme + Search Placeholder -->
      <div class="space-y-4">
        <div class="form-control">
          <div class="label pb-2 flex justify-between items-center">
            <span
              class="label-text font-bold text-[10px] uppercase tracking-[0.15em] text-slate-500"
              >Visual Theme</span
            >
            <button
              (click)="navigateToThemes()"
              class="text-[10px] font-black text-primary hover:underline flex items-center gap-1"
            >
              <svg lucideIcon="plus" class="size-3"></svg>
              MANAGE THEMES
            </button>
          </div>

          @if (themes.length > 0) {
          <div
            class="grid grid-cols-2 gap-2 max-h-56 overflow-y-auto pr-1 no-scrollbar"
          >
            @for (theme of themes; track theme.id) {
            <button
              type="button"
              (click)="selectTheme(theme)"
              class="group text-left rounded-2xl border p-3 transition-all bg-white hover:shadow-md"
              [ngClass]="
                newTabForm.theme_id === theme.id
                  ? 'border-primary/40 ring-2 ring-primary/15 shadow-sm'
                  : 'border-slate-100 hover:border-slate-200'
              "
            >
              <div class="flex items-center gap-2">
                <div
                  class="relative w-10 h-10 rounded-xl border border-slate-100 overflow-hidden shrink-0"
                  [style.background]="theme.theme_config.backgroundColor"
                >
                  <div
                    class="absolute inset-x-0 top-0 h-4"
                    [style.background]="theme.theme_config.headerColorStart"
                  ></div>
                  <div
                    class="absolute left-2 right-2 bottom-1.5 h-1.5 rounded-full"
                    [style.background]="theme.theme_config.primaryColor"
                  ></div>
                </div>
                <div class="min-w-0 flex-1">
                  <p class="text-[11px] font-black text-slate-800 truncate">
                    {{ theme.name }}
                  </p>
                  <div class="mt-1 flex gap-1">
                    <div
                      class="w-full h-1 rounded-full"
                      [style.background]="theme.theme_config.primaryColor"
                    ></div>
                    <div
                      class="w-full h-1 rounded-full opacity-30"
                      [style.background]="theme.theme_config.secondaryColor"
                    ></div>
                  </div>
                </div>
                @if (newTabForm.theme_id === theme.id) {
                <div
                  class="w-5 h-5 rounded-full bg-primary/10 flex items-center justify-center"
                >
                  <svg lucideIcon="check" class="text-primary size-3"></svg>
                </div>
                }
              </div>
            </button>
            }
          </div>
          } @else {
          <div
            class="py-10 text-center bg-slate-50 rounded-2xl border-2 border-dashed border-slate-200"
          >
            <p class="text-xs font-bold text-slate-400">
              No published themes found
            </p>
            <button
              (click)="navigateToThemes()"
              class="mt-2 text-[10px] font-black text-primary uppercase"
            >
              Create or Publish Theme
            </button>
          </div>
          }
        </div>

        <div class="form-control">
          <label for="tab-search" class="label pb-1"
            ><span
              class="label-text font-bold text-[10px] uppercase tracking-[0.15em] text-slate-500"
              >Search Placeholder</span
            ></label
          >
          <input
            id="tab-search"
            type="text"
            [(ngModel)]="newTabForm.search_placeholder"
            class="input input-md bg-white border-slate-200 shadow-sm font-bold text-slate-700 w-full rounded-2xl focus:border-primary focus:ring-4 focus:ring-primary/10 transition-all"
            placeholder="Search for items..."
          />
        </div>
      </div>

      <!-- Tab Icon Image Picker -->
      <div class="form-control">
        <label for="tab-icon-upload" class="label pb-1">
          <span
            class="label-text font-bold text-[10px] uppercase tracking-[0.15em] text-slate-500"
            >Tab Icon Image</span
          >
        </label>
        <div class="flex flex-col gap-3">
          @if (newTabForm.icon_url) {
            <div class="flex items-center justify-between p-4 bg-white border border-slate-200 rounded-3xl shadow-sm">
              <div class="flex items-center gap-3 min-w-0">
                <div class="w-12 h-12 rounded-2xl bg-slate-50 flex items-center justify-center shrink-0 border border-slate-100 overflow-hidden text-primary p-2">
                  <img [src]="newTabForm.icon_url" class="w-full h-full object-contain" alt="Icon" />
                </div>
                <div class="min-w-0">
                  <span class="text-xs font-bold block truncate">{{ newTabForm._pending_file?.name || 'Current Icon' }}</span>
                  <span class="text-[9px] text-slate-400 font-bold uppercase">Ready to upload</span>
                </div>
              </div>
              <button class="btn btn-sm btn-ghost text-error" type="button" (click)="removeIcon()">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/></svg>
              </button>
            </div>
          } @else {
            <app-image-uploader 
              type="HOME_TAB_ICON"
              [multiple]="false"
              (filesSelected)="onFilesValid($event)">
            </app-image-uploader>
          }
        </div>
      </div>

      <!-- Visibility Toggle -->
      <div
        class="form-control flex flex-row items-center bg-slate-50 p-4 rounded-2xl border border-slate-100"
      >
        <label
          class="label cursor-pointer p-0 flex items-center justify-between w-full"
        >
          <div class="flex flex-col gap-0.5">
            <span class="label-text font-black text-slate-800 text-sm"
              >Visible in App</span
            >
            <span
              class="text-[10px] text-slate-400 font-bold uppercase tracking-widest"
              >Enable to show this tab globally</span
            >
          </div>
          <input
            type="checkbox"
            [(ngModel)]="newTabForm.is_active"
            class="toggle toggle-primary shadow-sm"
          />
        </label>
      </div>
    </div>

    <!-- Actions - Fixed at Bottom -->
    <div
      class="shrink-0 pt-5 px-7 pb-7 bg-white/85 backdrop-blur-2xl border-t border-slate-100 flex items-center gap-3"
    >
      <button
        class="btn btn-ghost font-bold rounded-2xl flex-1 text-slate-500 bg-slate-50 hover:bg-slate-100"
        (click)="close()"
      >
        Cancel
      </button>
      <button
        class="btn btn-primary font-black uppercase text-xs tracking-widest rounded-2xl shadow-xl shadow-primary/30 hover:scale-[1.02] active:scale-95 transition-all flex-[2]"
        (click)="save()"
        [disabled]="!newTabForm.name?.trim()"
      >
        @if(isEditingTab) {
        <svg lucideIcon="save" class="mr-2 size-4"></svg>Save Changes } @else {
        <svg lucideIcon="plus" class="mr-2 size-4"></svg>Create Tab }
      </button>
    </div>
  </div>

  <form
    method="dialog"
    class="modal-backdrop bg-slate-900/40 backdrop-blur-sm"
    (click)="close()"
    (keyup.escape)="close()"
  >
    <button>close</button>
  </form>
</div>
}
